import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import './popover.css';

const Popover = ({ title, description, children }) => {
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const triggerRef = useRef();
    const [visible, setVisible] = useState(false);

    const showPopover = () => {
        const rect = triggerRef.current.getBoundingClientRect();
        const popoverHeight = 203;
        setCoords({
            top: rect.top + window.scrollY - popoverHeight - 8,
            left: rect.left + rect.width / 2 + window.scrollX
        });
        setVisible(true);
    };

    const hidePopover = () => {
        setVisible(false);
    };

    return (
        <>
            <span
                ref={triggerRef}
                className="popover-trigger"
                onMouseEnter={showPopover}
                onMouseLeave={hidePopover}
            >
                {children}
            </span>

            {visible &&
                ReactDOM.createPortal(
                    <div
                        className="popover-text popover-portal p-4 d-flex flex-column gap-1"
                        style={{ top: `${coords.top}px`, left: `${coords.left}px` }}
                        onMouseEnter={showPopover}
                        onMouseLeave={hidePopover}
                    >
                        <div className="popover-header d-flex flex-row align-items-center justify-content-between">
                            <div className="popover-title">{title}</div>
                            <i
                                className="bi bi-x"
                                role="button"
                                onClick={hidePopover}
                            ></i>
                        </div>
                        <div className="popover-description">{description}</div>
                        <button
                            className="button align-self-end popover-button"
                            onClick={hidePopover}
                        >
                            OK
                        </button>
                        <div className="popover-arrow"></div>
                    </div>,
                    document.body
                )}
        </>
    );
};

export default Popover;
